import { render, staticRenderFns } from "./main-surgery-dialog.vue?vue&type=template&id=a14a45da"
import script from "./main-surgery-dialog.vue?vue&type=script&lang=js"
export * from "./main-surgery-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports